import { LayoutProvider } from 'layout/context/layoutcontext';
import Layout from 'layout';
import SubmitResultRequest from 'features/Project/pages/SubmitResultRequest';
import { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import RegisterResultReviewForm from 'features/Project/pages/SubmitResult/ReviewForm';
import PropTypes from 'prop-types';

export default function SubmitResultRequestsPage({ isLiquidation }) {
  const [tab, setTab] = useState(0);
  return (
    <LayoutProvider>
      <Layout>
        <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
          <TabPanel header="Kết quả">
            <SubmitResultRequest isLiquidation={isLiquidation} />
          </TabPanel>
          <TabPanel header="Xem chi tiết">
            <RegisterResultReviewForm isLiquidation={isLiquidation} />
          </TabPanel>
        </TabView>
      </Layout>
    </LayoutProvider>
  );
}

SubmitResultRequestsPage.propTypes = {
  isLiquidation: PropTypes.bool,
};

SubmitResultRequestsPage.defaultProps = {
  isLiquidation: false,
};
